// @flow

import styled from 'styled-components';
import TextareaAutosize from 'react-textarea-autosize';

export default styled(TextareaAutosize)`
  color: ${props => props.theme[props.themeColor] || props.color || props.theme.contentTextColor};
  font-size: ${props => props.fontSize || '14px'};
  line-height: ${props => props.lineHeight || '20px'};
  font-weight: ${props => (props.bold ? 'bold' : 'normal')};
  letter-spacing: ${props => props.letterSpacing || 'normal'};
  line-height: ${props => props.lineHeight || 'normal'};
  text-align: ${props => props.textAlign || 'left'};
  font-family: 'Open Sans';
  width: 100%;
  box-sizing: border-box;
  padding: 8px 10px;
  border-radius: 4px;
  resize: none;
  border 1px solid ${props => props.theme.separatorOnWhite};

  :focus {
  outline: none;
  border 1px solid ${props => props.theme.brand};
  }

  &::placeholder {
  color: ${props => props.theme.avatarBorderColor};
  }
`;
